import React, { useState } from 'react';
import axios from 'axios';
import './ContactPage.css';

function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    subject: '',
    query: ''
  });

  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage({ type: '', text: '' });

    try {
      const response = await axios.post(
        'https://vjgmh8x1ca.execute-api.eu-west-1.amazonaws.com/prod/contact',
        formData,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200) {
        setMessage({
          type: 'success',
          text: 'Thank you! Your message has been sent successfully. Our team will get back to you shortly.'
        });
        setFormData({
          name: '',
          email: '',
          company: '',
          subject: '',
          query: ''
        });
      }
    } catch (error) {
      setMessage({
        type: 'error',
        text: error.response?.data?.message || 'Failed to send message. Please try again.'
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <main className="contact-page">
      <section className="contact-hero">
        <h1>Contact Us</h1>
        <p>Get in touch with NAK Engineering for your automation needs</p>
      </section>

      <div className="container">
        <div className="contact-content">
          <div className="contact-info">
            <div className="info-section">
              <h3>Get In Touch</h3>
              <p>Have a project in mind or need more information about our services? We'd love to hear from you.</p>
            </div>

            <div className="info-item">
              <h4>🌐 Website</h4>
              <p><a href="https://nakengineering.com">nakengineering.com</a></p>
            </div>

            <div className="info-item">
              <h4>💼 Services</h4>
              <ul>
                <li>PLC Programming</li>
                <li>Microchip Development</li>
                <li>Cloud Computing Integration</li>
                <li>IoT Solutions</li>
              </ul>
            </div>
          </div>

          <div className="contact-form-container">
            <h2>Send us a Message</h2>
            
            {message.text && (
              <div className={`message ${message.type}`}>
                {message.text}
              </div>
            )}

            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="John Doe"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="john@company.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="company">Company Name</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  placeholder="Your Company"
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder="Project Inquiry"
                />
              </div>

              <div className="form-group">
                <label htmlFor="query">Message *</label>
                <textarea
                  id="query"
                  name="query"
                  value={formData.query}
                  onChange={handleChange}
                  required
                  placeholder="Please describe your project or inquiry..."
                  rows="6"
                ></textarea>
              </div>

              <button 
                type="submit" 
                className="btn btn-primary"
                disabled={isLoading}
              >
                {isLoading ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </main>
  );
}

export default ContactPage;
